const submitToNetlify = async (formName, allFields) => {
  const formData = new URLSearchParams({
    "form-name": formName,
    ...allFields,
  })

  try {
    const netlifyResp = await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formData.toString(),
    })
    if (!netlifyResp.ok) {
      console.error("Netlify Forms Error:", netlifyResp.statusText)
    }
  } catch (err) {
    console.error("Unhadled error:", err)
  }
}

export default submitToNetlify
